import { Target } from 'lucide-react';
import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useBetting } from '../../../../../../../context/BettingContext';
import { sendNotfication } from '../../../../../../../Helper';
import { event } from 'jquery';
import { useExposure } from '../../../../../../../hooks/useExposure';

// Keyframes for odds change animations
const backOddsChange = keyframes`
  0% { 
    background: linear-gradient(90deg, #E3F2FD, #BBDEFB);
    box-shadow: 0 0 0 0 rgba(100, 181, 246, 0.7);
    border: 1px solid rgba(33, 150, 243, 0.4);
    transform: scale(1);
  }
  25% { 
    background: linear-gradient(90deg, #BBDEFB, #90CAF9);
    box-shadow: 0 0 8px 2px rgba(100, 181, 246, 0.6);
    border: 1px solid rgba(33, 150, 243, 0.8);
    transform: scale(1.02);
  }
  50% { 
    background: linear-gradient(90deg, #64B5F6, #42A5F5);
    box-shadow: 0 0 15px 4px rgba(100, 181, 246, 0.8);
    border: 1px solid rgba(33, 150, 243, 1);
    transform: scale(1.03);
  }
  75% { 
    background: linear-gradient(90deg, #BBDEFB, #90CAF9);
    box-shadow: 0 0 8px 2px rgba(100, 181, 246, 0.6);
    border: 1px solid rgba(33, 150, 243, 0.8);
    transform: scale(1.02);
  }
  100% { 
    background: linear-gradient(90deg, #E3F2FD, #BBDEFB);
    box-shadow: 0 0 0 0 rgba(100, 181, 246, 0);
    border: 1px solid rgba(33, 150, 243, 0.4);
    transform: scale(1);
  }
`;

const layOddsChange = keyframes`
  0% { 
    background: linear-gradient(90deg, #FFE6EA, #FFD4DA);
    box-shadow: 0 0 0 0 rgba(255, 182, 193, 0.7);
    border: 1px solid rgba(233, 30, 99, 0.4);
    transform: scale(1);
  }
  25% { 
    background: linear-gradient(90deg, #FFD4DA, #FFB6C1);
    box-shadow: 0 0 8px 2px rgba(255, 182, 193, 0.6);
    border: 1px solid rgba(233, 30, 99, 0.8);
    transform: scale(1.02);
  }
  50% { 
    background: linear-gradient(90deg, #FFB6C1, #FF9BB3);
    box-shadow: 0 0 15px 4px rgba(255, 182, 193, 0.8);
    border: 1px solid rgba(233, 30, 99, 1);
    transform: scale(1.03);
  }
  75% { 
    background: linear-gradient(90deg, #FFD4DA, #FFB6C1);
    box-shadow: 0 0 8px 2px rgba(255, 182, 193, 0.6);
    border: 1px solid rgba(233, 30, 99, 0.8);
    transform: scale(1.02);
  }
  100% { 
    background: linear-gradient(90deg, #FFE6EA, #FFD4DA);
    box-shadow: 0 0 0 0 rgba(255, 182, 193, 0);
    border: 1px solid rgba(233, 30, 99, 0.4);
    transform: scale(1);
  }
`;

const Container = styled.div`
  width: 100%;
   font-family: 'Montserrat Alternates', sans-serif;
  background: #000000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgb(50, 55, 56);
  color: white;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: bold;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const MatchedInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const InfoIcon = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #6E6E6E;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const ChartIcon = styled.span`
  color: #6E6E6E;
`;

const Table = styled.div`
  width: 100%;
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border-bottom: 1px solid rgb(50, 55, 56);
  // background: rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
`;

const HeaderCell = styled.div`
  width: 90px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  color: white;
  border-left: 1px solid rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:first-child {
    width: auto;
    border-left: none;
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border-bottom: 1px solid rgb(50, 55, 56);
  background: ${props => props.highlight ? '#1a1a1a' : '#000000'};
   font-family: 'Montserrat Alternates', sans-serif;
`;

const TeamCell = styled.div`
  padding: 12px;
  font-size: 11px;
  color: white;
  display: flex;
  align-items: center;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const OddsCell = styled.div`
  width: 90px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => {
    if (props.selected) {
      return props.type === 'back' ? '#72BBEF' : '#FFB6C1';
    }
    return props.type === 'back' ? '#72BBEF' : '#FFB6C1';
  }};
  border-left: 1px solid rgb(50, 55, 56);
  border: ${props => {
    if (props.animateBack) return '1px solid rgba(33, 150, 243, 0.4)';
    if (props.animateLay) return '1px solid rgba(233, 30, 99, 0.4)';
    return '1px solid transparent';
  }};
  cursor: pointer;
  font-family: 'Montserrat Alternates', sans-serif;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: ${props => {
    if (props.animateBack) return css`${backOddsChange} 2.5s cubic-bezier(0.4, 0, 0.2, 1)`;
    if (props.animateLay) return css`${layOddsChange} 2.5s cubic-bezier(0.4, 0, 0.2, 1)`;
    return 'none';
  }};

  .odds {
    font-weight: bold;
    font-size: 10px;
    color: black;
    transition: all 0.3s ease;
  }
  
  .volume {
    font-size: 8px;
    color: black;
    transition: all 0.3s ease;
  }

  &:hover {
    transform: scale(1.02);
  }
`;

// New styled components for bet container
const BetContainer = styled.div`
  padding: 2px 10px;
  background: ${props => props.betType === 'back' ? '#1a1a1a' : '#1a1a1a'};
  border-top: 1px solid rgb(50, 55, 56);
  color: white;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const BetInputContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 40px;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  overflow: hidden;
  background: #1a1a1a;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AdjustButton = styled.div`
  width: 40px;
  border: none;
  background: rgb(50, 55, 56);
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:hover {
    background: rgb(60, 65, 66);
  }

  &:active {
    background: rgb(40, 45, 46);
  }
`;

const BetInput = styled.div`
  flex: 1;
  padding: 8px;
  font-size: 16px;
  text-align: center;
  background: #1a1a1a;
  color: white;
  display: flex;
  min-width:100px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
`;

const QuickAmounts = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2px;
  margin-bottom: 8px;
`;

const QuickAmount = styled.div`
  padding: 4px;
  text-align: center;
  background: #1a1a1a;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:hover {
    background: rgb(50, 55, 56);
  }
`;

const NumberPad = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2px;
  width: 100%;
`;

const NumberButton = styled.div`
  padding: 12px;
  text-align: center;
  background: #1a1a1a;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:hover {
    background: rgb(50, 55, 56);
  }
`;

const CrossButton = styled(NumberButton)`
  font-weight: bold;
  font-size: 16px;
`;

const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  margin-top: 8px;
`;

const CancelButton = styled.div`
  padding: 10px;
  text-align: center;
  background: #1a1a1a;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 12px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const PlaceButton = styled.div`
  padding: 10px;
  text-align: center;
  background: #FF5C5C;
  border: 1px solid #FF5C5C;
  cursor: pointer;
  color: black;
  font-size: 12px;
  font-weight: bold;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 5px;
  color: white;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsCheckbox = styled.input`
  margin: 0;
  cursor: pointer;
`;

const quickAmounts = [100, 1000, 2000, 5000, 50000, 100000];

const InPlayBetMobile = ({ data }) => {
  const [oddsData, setOddsData] = useState([]);
  const [selectedBets, setSelectedBets] = useState({});
  const [betAmounts, setBetAmounts] = useState({});
  const [acceptAnyOdds, setAcceptAnyOdds] = useState({});
  const [previousOdds, setPreviousOdds] = useState({});
  const [animatingOdds, setAnimatingOdds] = useState({});
  const prevOddsDataRef = useRef();
  const { placeBets } = useBetting();
    const [betsCount, setBetsCount] = useState(0);

   const { getMatchExposure } = useExposure();
    const exposure = getMatchExposure(data.id);
  // ✅ Transform API odds data (same logic as desktop)
  const transformOddsData = (apiData) => {
    if (!apiData || !apiData.length) return [];

    const market = apiData[0];
    const teams = [];

    if (market.runners[0]) {
      teams.push({
        team: data.team1,
        key: 'team1',
        odds: [
          ...market.runners[0].ex.availableToBack.map(back => ({
            type: 'back',
            value: back.price || '--',
            volume: back.size || 0
          })),
          ...market.runners[0].ex.availableToLay.map(lay => ({
            type: 'lay',
            value: lay.price || '--',
            volume: lay.size || 0
          }))
        ]
      });
    }

    if (market.runners[1]) {
      teams.push({
        team: data.team2,
        key: 'team2',
        odds: [
          ...market.runners[1].ex.availableToBack.map(back => ({
            type: 'back',
            value: back.price || '--',
            volume: back.size || 0
          })),
          ...market.runners[1].ex.availableToLay.map(lay => ({
            type: 'lay',
            value: lay.price || '--',
            volume: lay.size || 0
          }))
        ]
      });
    }

    if (market.runners[2]) {
      teams.push({
        team: "The Draw",
        key: 'draw',
         odds: [
          ...market.runners[2].ex.availableToBack.map(back => ({
            type: 'back',
            value: back.price || '--',
            volume: back.size || 0
          })),
          ...market.runners[2].ex.availableToLay.map(lay => ({
            type: 'lay',
            value: lay.price || '--',
            volume: lay.size || 0
          }))
        ]
      });
    }

     if (market.runners[2]) {
      setBetsCount(3);
    } else {
      setBetsCount(2);
    }

    return teams;
  };
const token = localStorage.getItem('token');
  // ✅ Fetch odds data periodically
  useEffect(() => {
    const fetchOddsData = async () => {
      try {
        const res = await fetch(`https://api.ibitplay.com/sports/market-odds?market_id=${data.id}`, {
  headers: {
    'Authorization': `Bearer ${token}`
  }
});
        const json = await res.json();
        // console.log("Fetched odds datab ghg:", json);
        setOddsData(transformOddsData(json));
      } catch (err) {
        console.error("Error fetching odds:", err);
      }
    };

    fetchOddsData();
    const interval = setInterval(fetchOddsData, 2000);
    return () => clearInterval(interval);
  }, [data.id]);

  useEffect(() => {
  if (!oddsData.length) return;

  setSelectedBets(prev => {
    const updated = { ...prev };

    Object.entries(prev).forEach(([key, bet]) => {
      const teamRow = oddsData.find(row => row.key === bet.team);
      if (!teamRow) return;

      const newOdds =
        bet.type === "back"
          ? teamRow.odds[0]?.value   // best back
          : teamRow.odds[3]?.value;  // best lay

      if (newOdds) {
        updated[key] = { ...bet, liveOdds: newOdds };
      }
    });

    return updated;
  });
}, [oddsData]);

  // Effect to detect odds changes and trigger animations
  useEffect(() => {
    if (!oddsData || oddsData.length === 0) return;

    const currentOdds = {};
    oddsData.forEach((row, rowIndex) => {
      row.odds.forEach((odd, oddIndex) => {
        const key = `${rowIndex}-${oddIndex}`;
        currentOdds[key] = {
          value: odd.value,
          volume: odd.volume
        };
      });
    });

    const newAnimatingOdds = {};
    oddsData.forEach((row, rowIndex) => {
      row.odds.forEach((odd, oddIndex) => {
        const key = `${rowIndex}-${oddIndex}`;
        const prevOdd = previousOdds[key];
        
        if (prevOdd && (prevOdd.value !== odd.value || prevOdd.volume !== odd.volume)) {
          newAnimatingOdds[key] = true;
        }
      });
    });

    if (Object.keys(newAnimatingOdds).length > 0) {
      setAnimatingOdds(newAnimatingOdds);
      setTimeout(() => {
        setAnimatingOdds({});
      }, 2500);
    }
    setPreviousOdds(currentOdds);
    prevOddsDataRef.current = oddsData;
  }, [oddsData]);

  // ✅ Handle odds click (dynamic)

  const handleAmountChange = (betKey, amount) => {
  setBetAmounts((prev) => ({
    ...prev,
    [betKey]: amount.toString(),
  }));
};

  const handleCancelBet = (betKey) => {
    setSelectedBets(prev => {
      const newBets = { ...prev };
      delete newBets[betKey];
      return newBets;
    });

    setBetAmounts(prev => {
      const newAmounts = { ...prev };
      delete newAmounts[betKey];
      return newAmounts;
    });

    setAcceptAnyOdds(prev => {
      const newAccept = { ...prev };
      delete newAccept[betKey];
      return newAccept;
    });
  };
const handleOddsClick = (teamKey, type, odds) => {
  if (odds.value === '--') return;

  const betKey = `${teamKey}-${type}`;
  const oppositeType = type === 'back' ? 'lay' : 'back';
  const oppositeKey = `${teamKey}-${oppositeType}`;

  setSelectedBets(prev => {
    const newBets = { ...prev };
    if (newBets[betKey]) {
      delete newBets[betKey];
    } else {
      delete newBets[oppositeKey];
      newBets[betKey] = {
        team: teamKey,
        type,
        initialOdds: odds.value,   // ✅ lock odds when clicked
        liveOdds: odds.value,      // ✅ start live = initial
        odds: odds.value,
        volume: odds.volume,
      };
    }
    return newBets;
  });

  if (!betAmounts[betKey]) {
    setBetAmounts(prev => ({ ...prev, [betKey]: '100' }));
  }
};
  // Place inside InPlayBetMobile.jsx, above the return()
const TeamCellN = ({ team, matchTitle, matchId, market = 'MO' }) => {
  const ctx = useBetting() || {};
  const {
    teamValues = {},
    exposures = {},
    placedBets = [],
    getPL = () => 0,
  } = ctx;

  const formatValue = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n === 0) return '';
    return n;
  };

  const teamValue = teamValues?.[team] ?? { left: 0, right: 0 };

  const key = matchId != null ? String(matchId) : String(matchTitle || '');
  const tnorm = String(team || '').trim().toLowerCase();

  const current = exposures[key]?.teams?.[team] ?? 0;
  const local = getPL(market, team) || 0;
 const updated =  current ;

  const hasPrior =
    Array.isArray(placedBets) &&
    placedBets.some((b) => String(b.matchId ?? b.matchTitle) === key);

  const clsNew = updated < 0 ? 'text-red-600' : 'text-green-600';

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* Team name row */}
      <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'white' }}>
        {team}
      </div>

      {/* Old → New exposure */}
      <div className="mt-1 text-[11px] leading-none whitespace-nowrap">
        {hasPrior ? (
          <b
            className={clsNew}
            style={{ color: updated >= 0 ? 'green' : 'red' }}
          >
            {updated > 0 ? '+' : ''}
            {updated.toFixed(2)}
          </b>
        ) : (
          <b
            className={clsNew}
            style={{ color: updated >= 0 ? 'green' : 'red' }}
          >
            {updated > 0 ? '+' : ''}
            {updated.toFixed(2)}
          </b>
        )}
      </div>
    </div>
  );
};
const adjustBetAmount = (betKey, adjustment) => {
  setBetAmounts((prev) => {
    const currentAmount = Number(prev[betKey] || 0);
    const newAmount = Math.max(0, currentAmount + adjustment);
    return { ...prev, [betKey]: newAmount.toString() };
  });
};


  // ✅ Render bet slip container
  const renderBetContainer = (betKey, bet) => (
    <BetContainer key={betKey} betType={bet.type}>
      <div style={{ fontSize: '12px', color: 'white', textAlign: 'right', margin: "1px 6px" }}>Min Bet</div>
      <div style={{ display: 'flex', gap: '10px', margin: '4px 0', alignItems: 'center' }}>
        <BetInput>{bet.odds}</BetInput>
        <BetInputContainer>
          <AdjustButton onClick={() => adjustBetAmount(betKey, -10)}>−</AdjustButton>
          <BetInput>{betAmounts[betKey]}</BetInput>
          <AdjustButton onClick={() => adjustBetAmount(betKey, 10)}>+</AdjustButton>
        </BetInputContainer>
      </div>

      {/* Quick Amounts */}
      <QuickAmounts>
        {quickAmounts.map(amount => (
          <QuickAmount key={amount} onClick={() => handleAmountChange(betKey, amount)}>
            {amount}
          </QuickAmount>
        ))}
      </QuickAmounts>

      {/* Action Buttons */}
      <ActionButtons>
        <CancelButton onClick={() => handleCancelBet(betKey)}>Cancel</CancelButton>
       <PlaceButton
  onClick={async () => {
    const stake = parseFloat(betAmounts[betKey] || '0');
    const oddsNum = parseFloat(bet.odds || '0');

    if (!stake || stake < 4 || !oddsNum || oddsNum <= 1) {
      sendNotfication('Enter valid stake (>=4) and odds (>1).', 'error', 'bottom-left');
      return;
    }

    // ✅ Check odds mismatch
    if (Number(bet.initialOdds) !== Number(bet.liveOdds)) {
      sendNotfication(
        `Odds have changed! Old: ${bet.initialOdds}, New: ${bet.liveOdds}`,
        'error',
        'bottom-left'
      );
      return; // ❌ stop placing
    }

    const betRow = {
      market: 'MO',
      eventid: data.eventid,
      matchId: data.id,
       count: betsCount,
      matchTitle: `${data.team1} v ${data.team2}`,
      selectionName:
        bet.team === 'team1'
          ? data.team1
          : bet.team === 'team2'
          ? data.team2
          : 'The Draw',
      category: bet.team === 'draw' ? 'x' : bet.team === 'team1' ? '1' : '2',
      type: bet.type,
      odds: oddsNum,
      stake,
      liability: bet.type === 'lay' ? stake * (oddsNum - 1) : stake,
    };

    const result = await placeBets([betRow]);
    if (result?.confirmed?.length > 0) {
      sendNotfication('Bet placed successfully!', 'success', 'bottom-left');
      handleCancelBet(betKey);
    } else {
      sendNotfication(result?.errors?.[0]?.message || 'Bet failed', 'error', 'bottom-left');
    }
  }}
>
  Place Bet
</PlaceButton>

      </ActionButtons>
    </BetContainer>
  );

  return (
    <Container>
      <Header>
        <HeaderTitle><Target size={16} /> Match Odds</HeaderTitle>
        <MatchedInfo>Game Exposure : {Number(exposure).toFixed(2)}</MatchedInfo>
      </Header>

      <Table>
        <TableHeader>
          <HeaderCell></HeaderCell>
          <HeaderCell>Back</HeaderCell>
          <HeaderCell>Lay</HeaderCell>
        </TableHeader>

        {/* ✅ Dynamic Rows */}
        {oddsData.map(team => (
          <React.Fragment key={team.key}>
            <TableRow>
              <TeamCell>
  <TeamCellN
    team={team.team}
    matchTitle={`${data.team1} v ${data.team2}`}
    matchId={data.id}
  />
</TeamCell>
              {team.odds.slice(0, 1).map((odd, i) => {
                const key = `${oddsData.findIndex(row => row.key === team.key)}-${i}`;
                return (
                <OddsCell
                  key={i}
                  type="back"
                  onClick={() => handleOddsClick(team.key, 'back', odd)}
                  selected={selectedBets[`${team.key}-back`]}
                    animateBack={animatingOdds[key]}
                >
                  <span className="odds">{odd.value}</span>
                  <span className="volume">{odd.volume}</span>
                </OddsCell>
                );
              })}
              {team.odds.slice(3, 4).map((odd, i) => {
                const key = `${oddsData.findIndex(row => row.key === team.key)}-${i + 3}`;
                return (
                <OddsCell
                  key={i}
                  type="lay"
                  onClick={() => handleOddsClick(team.key, 'lay', odd)}
                  selected={selectedBets[`${team.key}-lay`]}
                    animateLay={animatingOdds[key]}
                >
                  <span className="odds">{odd.value}</span>
                  <span className="volume">{odd.volume}</span>
                </OddsCell>
                );
              })}
            </TableRow>

            {/* ✅ Bet Container per team */}
            {Object.entries(selectedBets)
              .filter(([key]) => key.startsWith(team.key))
              .map(([betKey, bet]) => renderBetContainer(betKey, bet))}
          </React.Fragment>
        ))}
      </Table>
    </Container>
  );
};

export default InPlayBetMobile;